import { CircularProgress, Stack } from '@mui/material'
import { FC } from 'react'

const LoadingContent: FC = () => {
  return (
    <Stack
      sx={{ flex: 1 }}
      alignItems="center"
      justifyContent="center"
      textAlign="center"
      padding={3}
    >
      <CircularProgress />
    </Stack>
  )
}

export default LoadingContent
